import React, { useState } from 'react'
import { InputsContainer } from '../../../ui/form'
import { FORM_TEXTS } from '../constants'
import Input from '../../../ui/input'

const SignUpStep1 = ({ values, errors, touched, handleChange, handleBlur }) => (
	<InputsContainer gap={24} mb={16}>
		<Input
			label={FORM_TEXTS.labels.name}
			name="name"
			placeholder={FORM_TEXTS.placeholders.name}
			value={values.name}
			onChange={handleChange}
			onBlur={handleBlur}
			error={touched.name && errors.name}
			fullWidth
		/>
		<Input
			label={FORM_TEXTS.labels.lastName}
			name="lastName"
			placeholder={FORM_TEXTS.placeholders.lastName}
			value={values.lastName}
			onChange={handleChange}
			onBlur={handleBlur}
			error={touched.lastName && errors.lastName}
			fullWidth
		/>
		<Input
			label={FORM_TEXTS.labels.email}
			type="email"
			name="email"
			placeholder={FORM_TEXTS.placeholders.email}
			value={values.email}
			onChange={handleChange}
			onBlur={handleBlur}
			error={touched.email && errors.email}
			fullWidth
		/>
		<Input
			label={FORM_TEXTS.labels.repeatEmail}
			type="email"
			name="repeatEmail"
			placeholder={FORM_TEXTS.placeholders.repeatEmail}
			value={values.repeatEmail}
			onChange={handleChange}
			onBlur={handleBlur}
			error={touched.repeatEmail && errors.repeatEmail}
			fullWidth
		/>
	</InputsContainer>
)

export default SignUpStep1
